import { httpClient } from '../http/httpClient'
import { PartnerType } from '@/app/utils/partners.enum'

export type ProductCatalogAlert = {
  active: boolean
  block: boolean
  title?: string
  subtitle?: string
  image?: string
  cta?: string
}

export type ProductCatalogItem = {
  key: PartnerType
  label: string
  description: string
  image: string
  color: string
  available: boolean
  alert?: ProductCatalogAlert
}

export async function getProductsCatalog() {
  const { data } = await httpClient.get<ProductCatalogItem[]>(
    'config/products/catalog',
  )
  return data
}
